import { flattenMenuPages, normalizeMenuHierarchy } from "./menuRouteMatcher";
import { menuHasPageCode } from "./menuPageAccess";

export const PLATE_POINT_PATH = "/plaka-nokta";
export const PLATE_POINT_PAGE_CODE = "plaka-nokta";

const normalizeTr = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/ı/g, "i")
    .replace(/İ/g, "i");

export const menuHasPlatePoint = (items) => {
  if (
    menuHasPageCode(items, PLATE_POINT_PAGE_CODE) ||
    menuHasPageCode(items, "plaka-ve-nokta") ||
    menuHasPageCode(items, "plaka-nokta-tanimlari")
  ) {
    return true;
  }
  const tree = Array.isArray(items) ? normalizeMenuHierarchy(items) : [];
  const flat = flattenMenuPages(tree.length ? tree : items);
  return flat.some((page) => {
    const name = normalizeTr(page && page.name);
    const url = normalizeTr(page && page.url).replace(/^\/+/, "");
    return (
      (name.indexOf("plaka") !== -1 && name.indexOf("nokta") !== -1) ||
      url === "plaka-nokta" ||
      url.indexOf("plaka-nokta") !== -1
    );
  });
};

export const ensurePlatePointRoutes = (routeList, allRoutes) => {
  const next = Array.isArray(routeList) ? [...routeList] : [];
  if (!Array.isArray(allRoutes)) return next;
  const route = allRoutes.find(
    (item) => item && item.path === PLATE_POINT_PATH
  );
  if (route && !next.some((item) => item.path === route.path)) {
    next.push(route);
  }
  return next;
};
